export default class BusinessTypes {
  static ROBOTIC = "robotic";

  static REGULAR = "regular";
}
